import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';

import icWhiteAdd from '../../assets/icons/white-add.png';
import icBlueAdd from '../../assets/icons/icBlueAdd.png';

const useStyles = makeStyles((theme) => ({
    iconMenuContainerSelect: {
        minWidth: 'unset',
        backgroundColor: '#237fc2',
        position: 'absolute',
        top: 14,
        right: 20,
        width: 25,
        height: 25,
        borderRadius: 10,
        border: 'solid 2px #e5f1f8',
        '&&:hover': {
            backgroundColor: '#e5f1f8',
        },
        padding:0,
    },
    iconMenuContainer: {
        minWidth: 'unset',
        backgroundColor: '#ffffff',
        position: 'absolute',
        top: 14,
        right: 20,
        width: 25,
        height: 25,
        borderRadius: 10,
        border: 'solid 2px #e5f1f8',
        padding:0,
    },
    iconMenu: {
        width: 14,
        height: 14,
    }
}));

function ThreeDotsButton({ active, ...props }) {
    const classes = useStyles();

    return active ?
        (
            <Button className={classes.iconMenuContainerSelect} {...props}>
                <img alt="three dots active button" src={icWhiteAdd} className={classes.iconMenu} />
            </Button>
        ) : (
            <Button className={classes.iconMenuContainer} {...props}>
                <img alt="three dots inactive button" src={icBlueAdd} className={classes.iconMenu} />
            </Button>
        )
}

ThreeDotsButton.propTypes = {
    active: PropTypes.bool.isRequired
}

export default ThreeDotsButton;
